function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#8c3123",
  d: "M21.54 23.23l-5.46 2.73v47.97l5.46 2.73 13.4-26.72-13.4-26.71z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#e05243",
  d: "M50 69.76l-28.46 6.89V23.23L50 30.12l13.45 19.9L50 69.76z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#8c3123",
  d: "M50 69.76l28.45 6.89 4.92-26.03-4.92-27.39L50 30.12v39.64z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#e05243",
  d: "M78.45 23.23l5.47 2.73v47.97l-5.47 2.73V23.23z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#8c3123",
  d: "M37.59 58.78L50 60.37l9.84-10.35L50 39.68l-12.41 1.56v17.54z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#5e1f18",
  d: "M62.41 32.75L50 35.01l-12.41-2.26L50 9l12.41 23.75z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#f2b0a9",
  d: "M62.41 67.25L50 64.97l-12.41 2.28L50 91l12.41-23.75z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#e05243",
  d: "M62.41 32.75L50 29.68V9l12.41 6.2v17.55z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#8c3123",
  d: "M37.59 32.75L50 29.68V9l-12.41 6.2v17.55z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#e05243",
  d: "M50 91l12.41-6.2V67.25L50 70.32V91z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "#8c3123",
  d: "M50 91l-12.41-6.2V67.25L50 70.32V91z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fill: "#e05243",
  d: "M62.41 58.78L50 60.37V39.68l12.41 1.56v17.54z"
});

function SvgS3ObjectArtifact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: 100,
    height: 100
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

export default __webpack_public_path__ + "s3-object-artifact.2fe59.svg";
export { SvgS3ObjectArtifact as ReactComponent };